import { useContext, useState } from "react";
import api from "../api";
import zxcvbn from "zxcvbn";
import { UserContext } from "../context/UserContext";
import PasswordStrengthMeter from "../components/PasswordStrengthMeter";
import PasswordPolicyChecklist from "../components/PasswordPolicyChecklist";
import "./home.css";

export default function ChangePassword() {
  const { user } = useContext(UserContext);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword]         = useState("");
  const [confirm, setConfirm]                 = useState("");
  const [loading, setLoading]                 = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const score = newPassword ? zxcvbn(newPassword, [user?.username, user?.email]).score : 0;

  const hasLower   = /[a-z]/.test(newPassword);
  const hasUpper   = /[A-Z]/.test(newPassword);
  const hasDigit   = /[0-9]/.test(newPassword);
  const hasSpecial = /[^A-Za-z0-9]/.test(newPassword);
  const noSpaces   = !/\s/.test(newPassword);
  const lenOK      = (newPassword?.length || 0) >= 10;
  const matches    = newPassword === confirm;

  const clientOK = lenOK && hasLower && hasUpper && hasDigit && hasSpecial && noSpaces && score >= 3 && matches;

  const submit = async (e) => {
    e.preventDefault();
    if (!matches) return alert("Die neuen Passwörter stimmen nicht überein.");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/change-password", { currentPassword, newPassword });
      alert(data.message || "Passwort geändert. Du wirst jetzt ausgeloggt.");
      await api.post("/auth/logout");
      setCurrentPassword(""); setNewPassword(""); setConfirm("");
  window.location.href = "/login?pwreset=1";
    } catch (e) {
      const r = e.response?.data;
      if (r?.reasons?.length) alert(r.reasons.join("\n"));
      else alert(r?.error || "Fehler beim Ändern des Passworts.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home-page">
  <section style={{width:'100vw', margin:0, padding:0, position:'relative', left:'-120px'}}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Passwort ändern</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>
          Ändere dein Passwort für mehr Sicherheit.<br/>
          Beachte die Passwort-Policy und wähle ein starkes Kennwort.
        </p>
      </section>

  <section style={{width:'100%',maxWidth:'1200px',margin:'0 auto',padding:0}}>
        <form className="highlight-card" style={{gap:18, padding:32}} onSubmit={submit}>
          <h2 className="highlight-title" style={{marginBottom:8}}>Neues Passwort setzen</h2>
          <div style={{position:'relative'}}>
            <input className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem", width:'100%'}} type={showCurrent ? "text" : "password"} placeholder="Aktuelles Passwort"
                   value={currentPassword} onChange={e=>setCurrentPassword(e.target.value)} required />
            <button
              type="button"
              aria-label={showCurrent ? "Passwort verbergen" : "Passwort anzeigen"}
              onClick={()=>setShowCurrent(v=>!v)}
              style={{
                position:'absolute',
                right:8,
                top:'50%',
                transform:'translateY(-50%)',
                background:'none',
                border:0,
                cursor:'pointer',
                color:'#32CD89',
                fontSize:'1.3em',
                padding:'4px 8px',
                lineHeight:1
              }}
            >
              {showCurrent ? "🙈" : "👁️"}
            </button>
          </div>
          <div style={{position:'relative'}}>
            <input className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem", width:'100%'}} type={showNew ? "text" : "password"} placeholder="Neues Passwort"
                   value={newPassword} onChange={e=>setNewPassword(e.target.value)} required />
            <button
              type="button"
              aria-label={showNew ? "Passwort verbergen" : "Passwort anzeigen"}
              onClick={()=>setShowNew(v=>!v)}
              style={{
                position:'absolute',
                right:8,
                top:'50%',
                transform:'translateY(-50%)',
                background:'none',
                border:0,
                cursor:'pointer',
                color:'#32CD89',
                fontSize:'1.3em',
                padding:'4px 8px',
                lineHeight:1
              }}
            >
              {showNew ? "🙈" : "👁️"}
            </button>
          </div>
          <PasswordStrengthMeter password={newPassword} userInputs={[user?.username, user?.email]} />
          <PasswordPolicyChecklist password={newPassword} />
          <div style={{position:'relative'}}>
            <input className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem", width:'100%'}} type={showConfirm ? "text" : "password"} placeholder="Neues Passwort bestätigen"
                   value={confirm} onChange={e=>setConfirm(e.target.value)} required />
            <button
              type="button"
              aria-label={showConfirm ? "Passwort verbergen" : "Passwort anzeigen"}
              onClick={()=>setShowConfirm(v=>!v)}
              style={{
                position:'absolute',
                right:8,
                top:'50%',
                transform:'translateY(-50%)',
                background:'none',
                border:0,
                cursor:'pointer',
                color:'#32CD89',
                fontSize:'1.3em',
                padding:'4px 8px',
                lineHeight:1
              }}
            >
              {showConfirm ? "🙈" : "👁️"}
            </button>
          </div>
          <button type="submit" className="hero-btn-primary" style={{marginTop:8}} disabled={!clientOK || loading}>
            {loading ? "Speichern ..." : "Passwort ändern"}
          </button>
        </form>
      </section>
    </div>
  );
}
